// services/redux/api/endpoints/general/tpaMaster.js
export const tpaMasterEndpoints = (builder) => ({
  getTPAMasters: builder.query({
    query: (params) => ({
      url: '/TPAMaster/get-tpa-list',
      method: 'POST',
      body: params,
    }),
    providesTags: ['TPAMaster'],
  }),
});
